import React from 'react';
import { useTeamSetupAreasService } from 'nekst-api';
import { ButtonSize, OptionSelectionButton } from 'ui-builder';
import { usePopupFormManager, ConfirmDeletePopup, ConfirmPositiveActionPopup } from 'features/nekst-widgets';
import { useTeamSetupAreaContextRequired } from './TeamSetupAreaContext';
import useSettingsNavigator from '../settingsNavigator';

export default function MarketActionsButton() {
  const popupManager = usePopupFormManager();
  const { teamSetupArea } = useTeamSetupAreaContextRequired();
  const teamSetupAreasService = useTeamSetupAreasService();
  const settingsNavigator = useSettingsNavigator();

  const handleArchive = () => {
    popupManager.openForm(
      <ConfirmDeletePopup
        title="Archive Market"
        message={`Are you sure you want to archive "${teamSetupArea.name}"? This action can be undone later.`}
        deleteFunc={async () => {
          await teamSetupAreasService.archiveSetupArea(teamSetupArea.id);
          settingsNavigator.openMarketsPage();
        }}
        withConfirmationInput
      />
    );
  };

  const handleMakeDefault = () => {
    popupManager.openForm(
      <ConfirmPositiveActionPopup
        title="Set Default Market"
        message={`Make "${teamSetupArea.name}" the default market? This will affect new projects.`}
        buttonText="Set as Default"
        submitFormFunc={async () => {
          await teamSetupAreasService.setDefaultSetupArea(teamSetupArea.id);
        }}
      />
    );
  };

  const options = [
    !teamSetupArea.isDefault && {
      label: 'Make as Default',
      value: 'make-default',
      onSelected: handleMakeDefault,
    },
    {
      label: 'Archive Market',
      value: 'archive',
      onSelected: handleArchive,
    },
  ];

  return (
    <OptionSelectionButton
      text="Actions"
      size={ButtonSize.MEDIUM}
      options={options}
    />
  );
}